import FeatureToggle, { Feature } from "./FeatureToggle";

export { Feature, FeatureToggle };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/FeatureToggle/index.tsx